<div *kienePermission="[4001]" style="padding: 12px">
    <div class="one-row">
        <h1 [attr.data-cy]="'ctt_h1_1_4_'">Tourenplan</h1>
        <span class="spacer" [attr.data-cy]="'ctt_span_1_9_'"></span>
        <div>
            <button
                *kienePermission="[1162]"
                color="accent"
                mat-icon-button
                (click)="openAddTourDialog()"
                [attr.data-cy]="'ctt_button_1_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_1_2_'">add</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="!isMobileScreen" class="one-row">
        <h4>f&uuml;r {{ kieneSession.vorname }} {{ kieneSession.nachname }}</h4>
        <span class="spacer" [attr.data-cy]="'ctt_span_2_9_'"></span>
        <mat-form-field *ngIf="!isKunde">
            <mat-select
                placeholder="Tierarztgruppe"
                [formControl]="tierarztgruppeCtrl"
                [compareWith]="vetGroupComparator"
            >
                <mat-option>--</mat-option>
                <mat-option
                    *ngFor="let t of tierarztgruppen; let i = index"
                    [attr.data-cy]="'ctt_opt_1_' + i"
                    [value]="t"
                    >{{ t.bezeichnung }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span class="spacer" [attr.data-cy]="'ctt_span_3_9_'"></span>
        <div *ngIf="!isKunde" class="one-row" style="width: 25%">
            <mat-slide-toggle
                color="accent"
                style="margin-right: 5px"
                [formControl]="onlyMineCtrl"
                [attr.data-cy]="'ctt_mat-slide-toggle_1_11_'"
                >Nur meine
            </mat-slide-toggle>

            <span class="spacer" [attr.data-cy]="'ctt_span_4_9_'"></span>
            <span
                style="color: #555; font-weight: bold"
                [matBadgeHidden]="kwInfo < 1 || selectedOption != 'Heute'"
                [matBadge]="kwInfo"
                [matTooltip]="selectedOption === 'Heute' && kwInfo > 0 ? 'Diese KW noch ' + kwInfo + ' Einträge' : ''"
                [attr.data-cy]="'ctt_span_5_9_'"
                >{{ selectedOption }}</span
            >
            <span class="spacer" [attr.data-cy]="'ctt_span_6_9_'"></span>

            <button
                mat-icon-button
                color="accent"
                (click)="reload()"
                matTooltip="Seite neu laden"
                [attr.data-cy]="'ctt_button_2_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_2_2_'">refresh</mat-icon>
            </button>

            <button
                mat-icon-button
                color="accent"
                [matMenuTriggerFor]="menu"
                aria-label="filter menu button"
                matTooltip="Tourenplan filtern"
                [attr.data-cy]="'ctt_button_3_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_3_2_'">filter_list</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="setzeOptions(1, true)" [attr.data-cy]="'ctt_button_4_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_4_2_'">filter_list_off</mat-icon>
                    <span [attr.data-cy]="'ctt_span_7_9_'">Alle</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(2, true)" [attr.data-cy]="'ctt_button_5_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_5_2_'">today</mat-icon>
                    <span [attr.data-cy]="'ctt_span_8_9_'">Heute</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(4, true)" [attr.data-cy]="'ctt_button_6_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_6_2_'">view_week</mat-icon>
                    <span [attr.data-cy]="'ctt_span_9_9_'">Kalenderwoche</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(3, true)" [attr.data-cy]="'ctt_button_7_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_7_2_'">history</mat-icon>
                    <span [attr.data-cy]="'ctt_span_10_9_'">Historie</span>
                </button>
            </mat-menu>

            <button
                color="accent"
                mat-icon-button
                (click)="downloadTourenplan()"
                matTooltip="Tourenplan herunterladen"
                [attr.data-cy]="'ctt_button_8_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_8_2_'">cloud_download</mat-icon>
            </button>
            <button
                *ngIf="isVet"
                color="accent"
                mat-icon-button
                (click)="route()"
                matTooltip="Heutige Route in Google Maps öffnen"
                [attr.data-cy]="'ctt_button_9_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_9_2_'">directions</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="isMobileScreen">
        <h4 style="width: 100%; margin-top: 5px; margin-bottom: 5px">
            f&uuml;r {{ kieneSession.vorname }} {{ kieneSession.nachname }}
        </h4>
        <div class="one-row">
            <mat-form-field *ngIf="!isKunde" style="width: 66%">
                <mat-select
                    placeholder="Tierarztgruppe"
                    [formControl]="tierarztgruppeCtrl"
                    [compareWith]="vetGroupComparator"
                >
                    <mat-option>--</mat-option>
                    <mat-option
                        *ngFor="let t of tierarztgruppen; let i = index"
                        [attr.data-cy]="'ctt_opt_2_' + i"
                        [value]="t"
                        >{{ t.bezeichnung }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <span class="spacer" [attr.data-cy]="'ctt_span_11_9_'"></span>
            <button color="accent" mat-icon-button (click)="downloadTourenplan()" [attr.data-cy]="'ctt_button_10_0_'">
                <mat-icon [attr.data-cy]="'ctt_mat-icon_10_2_'">cloud_download</mat-icon>
            </button>
            <span class="spacer" [attr.data-cy]="'ctt_span_12_9_'"></span>
            <button *ngIf="isVet" color="accent" mat-icon-button (click)="route()" [attr.data-cy]="'ctt_button_11_0_'">
                <mat-icon [attr.data-cy]="'ctt_mat-icon_11_2_'">directions</mat-icon>
            </button>
        </div>

        <div *ngIf="!isKunde" style="width: 100%; margin-bottom: 6px" class="one-row">
            <mat-slide-toggle
                color="accent"
                style="margin-right: 5px"
                [formControl]="onlyMineCtrl"
                [attr.data-cy]="'ctt_mat-slide-toggle_2_11_'"
                >Nur meine
            </mat-slide-toggle>

            <span class="spacer" [attr.data-cy]="'ctt_span_13_9_'"></span>
            <span
                style="color: #555; font-weight: bold"
                [matBadgeHidden]="kwInfo < 1 || selectedOption != 'Heute'"
                [matBadge]="kwInfo"
                [matTooltip]="selectedOption === 'Heute' && kwInfo > 0 ? 'Diese KW noch ' + kwInfo + ' Einträge' : ''"
                [attr.data-cy]="'ctt_span_14_9_'"
                >{{ selectedOption }}</span
            >
            <span class="spacer" [attr.data-cy]="'ctt_span_15_9_'"></span>

            <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="filter menu button"
                [attr.data-cy]="'ctt_button_12_0_'"
            >
                <mat-icon [attr.data-cy]="'ctt_mat-icon_12_2_'">filter_list</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="setzeOptions(1, true)" [attr.data-cy]="'ctt_button_13_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_13_2_'">filter_list_off</mat-icon>
                    <span [attr.data-cy]="'ctt_span_16_9_'">Alle</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(2, true)" [attr.data-cy]="'ctt_button_14_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_14_2_'">today</mat-icon>
                    <span [attr.data-cy]="'ctt_span_17_9_'">Heute</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(4, true)" [attr.data-cy]="'ctt_button_15_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_15_2_'">view_week</mat-icon>
                    <span [attr.data-cy]="'ctt_span_18_9_'">Kalenderwoche</span>
                </button>
                <button mat-menu-item (click)="setzeOptions(3, true)" [attr.data-cy]="'ctt_button_16_0_'">
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_16_2_'">history</mat-icon>
                    <span [attr.data-cy]="'ctt_span_19_9_'">Historie</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div *ngIf="isMobileScreen">
        <mat-card
            style="margin-bottom: 15px"
            *ngFor="let t of tourenplans; let i = index"
            [ngClass]="isStatus(t, 2) ? 'background-red' : ''"
            [attr.data-cy]="'ctt_mat-card_1_6_' + i"
        >
            <div class="one-row">
                <p style="font-weight: bold" [attr.data-cy]="'ctt_p_1_5_' + i">
                    {{ t.kunde }} {{ t.zusatz }}
                    {{ !t.kunde ? t.unternehmensgruppe : "" }}
                </p>
                <button
                    *kienePermission="[4006]"
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    [attr.data-cy]="'ctt_button_17_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_17_2_' + i">more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <a
                        class="phone-button"
                        href="{{ 'tel:' + t.telefon_1 }}"
                        [disabled]="t.telefon_1 === null"
                        mat-menu-item
                        [attr.data-cy]="'ctt_a_1_8_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_18_2_'">phone</mat-icon>
                        <span [attr.data-cy]="'ctt_span_20_9_'">Festnetz anrufen</span>
                    </a>
                    <a
                        class="phone-button"
                        href="{{ 'tel:' + t.mobil_1 }}"
                        [disabled]="t.mobil_1 === null"
                        mat-menu-item
                        [attr.data-cy]="'ctt_a_2_8_'"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_19_2_'">phone_iphone </mat-icon>
                        <span [attr.data-cy]="'ctt_span_21_9_'">Mobil anrufen</span>
                    </a>
                    <button mat-menu-item (click)="goToBehandlungsanfrage(t)" [attr.data-cy]="'ctt_button_18_0_'">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_20_2_'">insert_drive_file </mat-icon>
                        <span [attr.data-cy]="'ctt_span_22_9_'">Behandlungsanfr. anzeigen</span>
                    </button>
                    <button mat-menu-item (click)="editTour(t)" [attr.data-cy]="'ctt_button_19_0_'">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_21_2_'">edit</mat-icon>
                        <span [attr.data-cy]="'ctt_span_23_9_'">Bearbeiten</span>
                    </button>
                    <button mat-menu-item (click)="deleteTour(t)" [attr.data-cy]="'ctt_button_20_0_'">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_22_2_'">delete</mat-icon>
                        <span [attr.data-cy]="'ctt_span_24_9_'">Löschen</span>
                    </button>
                    <button
                        *ngIf="isStatus(t, 2)"
                        mat-menu-item
                        (click)="release(t)"
                        [attr.data-cy]="'ctt_button_21_0_'"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_23_2_' + i">thumb_up</mat-icon>
                        <span [attr.data-cy]="'ctt_span_25_9_' + i">Freigeben</span>
                    </button>
                </mat-menu>
            </div>
            <div class="one-row">
                <mat-icon color="accent" [attr.data-cy]="'ctt_mat-icon_24_2_' + i">place</mat-icon>
                <kiene-google-maps-route
                    style="font-size: 0.8em; text-align: left; color: #aaa"
                    [strasse]="getStrasse(t)"
                    [plz]="getPlz(t)"
                    [ort]="getOrt(t)"
                    [attr.data-cy]="'ctt_kgmr_1_' + i"
                ></kiene-google-maps-route>
                <span class="spacer" [attr.data-cy]="'ctt_span_26_9_' + i"></span>
            </div>

            <div class="one-row" style="font-size: 0.8em; font-weight: bold">
                <p *ngIf="t.zieldatum" [attr.data-cy]="'ctt_p_2_5_' + i">
                    Ziel: {{ t.zieldatum | date: "mediumDate" }}
                </p>
                <p *ngIf="t.zieldatum_bis" [attr.data-cy]="'ctt_p_3_5_' + i">
                    - {{ t.zieldatum_bis | date: "mediumDate" }}
                </p>
                <span class="spacer" [attr.data-cy]="'ctt_span_27_9_' + i"></span>
            </div>

            <div class="one-row">
                <div style="width: 100px">
                    <mat-icon
                        matTooltip="Artikel müssen in der Apotheke abgeholt werden"
                        color="primary"
                        *ngIf="isApotheke(t) && !isKunde"
                        [attr.data-cy]="'ctt_mat-icon_25_2_'"
                    >
                        local_pharmacy
                    </mat-icon>
                </div>
                <div *ngIf="isApotheke(t) && isStatus(t, 3) && !isKunde" class="red" style="width: 100px">
                    <mat-icon matTooltip="Bestellung noch nicht kommissioniert" [attr.data-cy]="'ctt_mat-icon_26_2_'"
                        >local_shipping
                    </mat-icon>
                </div>
                <button
                    mat-icon-button
                    *ngIf="isApotheke(t) && isStatus(t, 4) && !isKunde"
                    class="orange"
                    (click)="bestellungAbgeholt(t)"
                    style="width: 100px"
                    [attr.data-cy]="'ctt_button_22_0_'"
                >
                    <mat-icon matTooltip="Bestellung kann abgeholt werden" [attr.data-cy]="'ctt_mat-icon_27_2_'"
                        >local_shipping
                    </mat-icon>
                </button>
                <div *ngIf="isApotheke(t) && isStatus(t, 5) && !isKunde" class="green" style="width: 100px">
                    <mat-icon matTooltip="Bestellung wurde abgeholt" [attr.data-cy]="'ctt_mat-icon_28_2_'"
                        >local_shipping
                    </mat-icon>
                </div>
                <span class="spacer" [attr.data-cy]="'ctt_span_28_9_'"></span>
            </div>

            <p *ngIf="t.bezeichnung" [attr.data-cy]="'ctt_p_4_5_' + i">{{ t.bezeichnung }}</p>
            <ul style="padding: 0; margin: 0; list-style-type: none">
                <li
                    *ngFor="let p of t.positionen; let j = index"
                    [attr.data-cy]="'ctt_li_1_5_' + i + '_' + j"
                    style="margin-bottom: 12px"
                >
                    <p
                        style="font-size: 0.9em; font-weight: bold; padding-bottom: 0px; margin-bottom: 0px"
                        [attr.data-cy]="'ctt_p_5_5_' + i + '_' + j"
                    >
                        {{ p.artikelmenge | number: "1.0-1" }}x
                        {{ p.artikel_me }}
                    </p>
                    <p
                        *ngIf="p.anzahl_tiere && p.anzahl_tiere > 0"
                        [attr.data-cy]="'ctt_p_6_5_' + i + '_' + j"
                        style="
                            margin: 0px;
                            padding: 0px;
                            width: 280px;
                            white-space: nowrap;
                            overflow: hidden;
                            font-size: 0.9em;
                            color: #555;
                            text-overflow: ellipsis;
                        "
                    >
                        Tiere: {{ p.anzahl_tiere }}
                    </p>
                    <p
                        style="
                            margin: 0px;
                            padding: 0px;
                            width: 280px;
                            white-space: nowrap;
                            overflow: hidden;
                            font-size: 0.9em;
                            color: #555;
                            text-overflow: ellipsis;
                        "
                        [attr.data-cy]="'ctt_p_7_5_' + i + '_' + j"
                    >
                        {{ p.identifikation }}
                    </p>
                </li>
            </ul>

            <div class="one-row" style="border-top: 1px solid gray; padding-top: 12px; margin-top: 12px">
                <button
                    *ngIf="isTourenplanActive(t)"
                    mat-icon-button
                    color="accent"
                    (click)="done(t)"
                    style="margin-right: 12px"
                    [attr.data-cy]="'ctt_button_23_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_29_2_' + i">check</mat-icon>
                </button>
                <button
                    *ngIf="isTourenplanDone(t)"
                    mat-icon-button
                    color="accent"
                    (click)="undone(t)"
                    style="margin-right: 12px"
                    [attr.data-cy]="'ctt_button_24_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_30_2_' + i">clear</mat-icon>
                </button>
                <button
                    mat-icon-button
                    color="accent"
                    (click)="transformAbgabebeleg(t)"
                    matTooltip="In Abgabebeleg umwandeln"
                    [attr.data-cy]="'ctt_button_25_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_31_2_' + i">transform</mat-icon>
                </button>
                <span class="spacer" [attr.data-cy]="'ctt_span_29_9_' + i"></span>

                <button
                    *ngIf="!t.tierarzt"
                    mat-icon-button
                    (click)="assignToVet(t)"
                    [attr.data-cy]="'ctt_button_26_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_32_2_' + i">person_add</mat-icon>
                </button>
                <div *ngIf="t.tierarzt">
                    <button mat-button (click)="releaseVet(t)" [attr.data-cy]="'ctt_button_27_0_' + i">
                        {{ t.tierarzt }}
                    </button>
                </div>
            </div>
        </mat-card>

        <mat-paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)"
        >
        </mat-paginator>
    </div>

    <div *ngIf="!isMobileScreen">
        <!-- cards -->
        <mat-card
            style="margin-bottom: 15px"
            *ngFor="let t of tourenplans; let i = index"
            [ngClass]="isStatus(t, 2) ? 'background-red' : ''"
            [attr.data-cy]="'ctt_mat-card_2_6_' + i"
        >
            <mat-card-header class="card-header" [attr.data-cy]="'ctt_mat-card_3_6_' + i">
                <mat-icon mat-card-avatar [attr.data-cy]="'ctt_mat-icon_33_2_' + i">place</mat-icon>
                <mat-card-title style="font-weight: bold" [attr.data-cy]="'ctt_mat-card_4_6_' + i"
                    >{{ t.kunde }} {{ t.zusatz }} {{ !t.kunde ? t.unternehmensgruppe : "" }}<br />
                    <kiene-google-maps-route
                        style="font-size: 0.6em; text-align: left; color: #aaa"
                        [strasse]="getStrasse(t)"
                        [plz]="getPlz(t)"
                        [ort]="getOrt(t)"
                        [attr.data-cy]="'ctt_kgmr_2_' + i"
                    ></kiene-google-maps-route>
                </mat-card-title>
                <button
                    *kienePermission="[4006]"
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    [attr.data-cy]="'ctt_button_28_0_' + i"
                >
                    <mat-icon [attr.data-cy]="'ctt_mat-icon_34_2_' + i">more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <a
                        class="phone-button"
                        href="{{ 'tel:' + t.telefon_1 }}"
                        [disabled]="t.telefon_1 === null"
                        mat-menu-item
                        [attr.data-cy]="'ctt_a_3_8_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_35_2_' + i">phone</mat-icon>
                        <span [attr.data-cy]="'ctt_span_30_9_' + i">Festnetz anrufen</span>
                    </a>
                    <a
                        class="phone-button"
                        href="{{ 'tel:' + t.mobil_1 }}"
                        [disabled]="t.mobil_1 === null"
                        mat-menu-item
                        [attr.data-cy]="'ctt_a_4_8_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_36_2_' + i">phone_iphone </mat-icon>
                        <span [attr.data-cy]="'ctt_span_31_9_' + i">Mobil anrufen</span>
                    </a>
                    <button mat-menu-item (click)="goToBehandlungsanfrage(t)" [attr.data-cy]="'ctt_button_29_0_' + i">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_37_2_' + i">insert_drive_file </mat-icon>
                        <span [attr.data-cy]="'ctt_span_32_9_' + i">Behandlungsanfr. anzeigen</span>
                    </button>
                    <button mat-menu-item (click)="editTour(t)" [attr.data-cy]="'ctt_button_30_0_' + i">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_38_2_' + i">edit</mat-icon>
                        <span [attr.data-cy]="'ctt_span_33_9_'">Bearbeiten</span>
                    </button>
                    <button mat-menu-item (click)="deleteTour(t)" [attr.data-cy]="'ctt_button_31_0_' + i">
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_39_2_' + i">delete</mat-icon>
                        <span [attr.data-cy]="'ctt_span_34_9_' + i">Löschen</span>
                    </button>
                    <button
                        *ngIf="isStatus(t, 2)"
                        mat-menu-item
                        (click)="release(t)"
                        [attr.data-cy]="'ctt_button_32_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_40_2_' + i">thumb_up</mat-icon>
                        <span [attr.data-cy]="'ctt_span_35_9_' + i">Freigeben</span>
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content [attr.data-cy]="'ctt_mat-card_5_6_' + i">
                <div class="one-row">
                    <mat-icon
                        matTooltip="Artikel müssen in der Apotheke abgeholt werden"
                        color="primary"
                        *ngIf="isApotheke(t) && !isKunde"
                        [attr.data-cy]="'ctt_mat-icon_41_2_' + i"
                    >
                        local_pharmacy
                    </mat-icon>
                    <div *ngIf="isApotheke(t) && isStatus(t, 3) && !isKunde" class="red">
                        <mat-icon
                            matTooltip="Bestellung noch nicht kommissioniert"
                            [attr.data-cy]="'ctt_mat-icon_42_2_' + i"
                            >local_shipping
                        </mat-icon>
                    </div>
                    <button
                        mat-icon-button
                        *ngIf="isApotheke(t) && isStatus(t, 4) && !isKunde"
                        class="orange"
                        (click)="bestellungAbgeholt(t)"
                        [attr.data-cy]="'ctt_button_33_0_' + i"
                    >
                        <mat-icon matTooltip="Bestellung kann abgeholt werden" [attr.data-cy]="'ctt_mat-icon_43_2_' + i"
                            >local_shipping
                        </mat-icon>
                    </button>
                    <div *ngIf="isApotheke(t) && isStatus(t, 5) && !isKunde" class="green">
                        <mat-icon matTooltip="Bestellung wurde abgeholt" [attr.data-cy]="'ctt_mat-icon_44_2_' + i"
                            >local_shipping
                        </mat-icon>
                    </div>
                    <span class="spacer" [attr.data-cy]="'ctt_span_36_9_' + i"></span>
                    <div>
                        <p *ngIf="t.zieldatum" [attr.data-cy]="'ctt_p_8_5_' + i">
                            Ziel: {{ t.zieldatum | date: "mediumDate" }}
                        </p>
                        <p *ngIf="t.zieldatum_bis" [attr.data-cy]="'ctt_p_9_5_' + i">
                            Bis: {{ t.zieldatum_bis | date: "mediumDate" }}
                        </p>
                    </div>
                </div>
                <p *ngIf="t.bezeichnung" [attr.data-cy]="'ctt_p_10_5_' + i">{{ t.bezeichnung }}</p>
                <div>
                    <table *ngIf="t.positionen.length > 0" class="phito-table">
                        <thead>
                            <tr>
                                <th [attr.data-cy]="'ctt_th_1_10_' + i">Pos.</th>
                                <th [attr.data-cy]="'ctt_th_2_10_' + i">Artikel</th>
                                <th [attr.data-cy]="'ctt_th_3_10_' + i">Menge</th>
                                <th [attr.data-cy]="'ctt_th_4_10_' + i">Tiere</th>
                                <th [attr.data-cy]="'ctt_th_5_10_' + i">Identifikation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let p of t.positionen; let j = index"
                                [attr.data-cy]="'ctt_tr_1_7_' + i + '_' + j"
                            >
                                <td [attr.data-cy]="'ctt_td_1_7_' + i + '_' + j">{{ p.position }}</td>
                                <td [attr.data-cy]="'ctt_td_2_7_' + i + '_' + j">{{ p.artikel_me }}</td>
                                <td [attr.data-cy]="'ctt_td_3_7_' + i + '_' + j">{{
                                    p.artikelmenge | number: "1.0-1"
                                }}</td>
                                <td [attr.data-cy]="'ctt_td_4_7_' + i + '_' + j">{{
                                    p.anzahl_tiere | number: "1.0-0"
                                }}</td>
                                <td [attr.data-cy]="'ctt_td_5_7_' + i + '_' + j">{{ p.identifikation }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-card-content>
            <mat-card-footer class="footer" *ngIf="!isKunde" [attr.data-cy]="'ctt_mat-card_6_6_' + i">
                <div class="one-row">
                    <button
                        *ngIf="isTourenplanActive(t)"
                        mat-mini-fab
                        color="accent"
                        (click)="done(t)"
                        style="margin-right: 12px"
                        matTooltip="Als erledigt markieren"
                        [attr.data-cy]="'ctt_button_34_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_45_2_' + i">check</mat-icon>
                    </button>
                    <button
                        *ngIf="isTourenplanDone(t)"
                        mat-mini-fab
                        color="accent"
                        (click)="undone(t)"
                        style="margin-right: 12px"
                        [attr.data-cy]="'ctt_button_35_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_46_2_' + i">clear</mat-icon>
                    </button>
                    <button
                        mat-mini-fab
                        color="accent"
                        (click)="transformAbgabebeleg(t)"
                        matTooltip="In Abgabebeleg umwandeln"
                        [attr.data-cy]="'ctt_button_36_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_47_2_' + i">transform</mat-icon>
                    </button>
                    <span class="spacer" [attr.data-cy]="'ctt_span_37_9_' + i"></span>

                    <button
                        *ngIf="!t.tierarzt"
                        mat-icon-button
                        (click)="assignToVet(t)"
                        [attr.data-cy]="'ctt_button_37_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'ctt_mat-icon_48_2_' + i">person_add</mat-icon>
                    </button>
                    <div *ngIf="t.tierarzt">
                        <button mat-button (click)="releaseVet(t)" [attr.data-cy]="'ctt_button_38_0_' + i">
                            {{ t.tierarzt }}
                        </button>
                    </div>
                </div>
            </mat-card-footer>
        </mat-card>
        <mat-paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)"
        >
        </mat-paginator>
    </div>
</div>
